export default __webpack_public_path__ + "static/global-filters-dark-mode-dd5ca3c665336852fea8cb53c29e13c0.png";